import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketItemPerson`;

const ApiBasketItemPerson = {
  getBasketItemPersonsReport: (params) => {
    const url = `${baseServiceUrl}/basketItemPersonsReport`;
    return ServiceApi.get(url, { params });
  },
  // getBasketItemPersonsReportByExcel: (params) => {
  //   const url = `${baseServiceUrl}/getBasketItemPersonsReportByExcel`;
  //   return  ServiceApi.get(url,  {params : params , responseType : 'blob'} );
  // },
  cancleBasketItemPerson: (params) => {
    console.log("paramss=", params)
    const url = `${baseServiceUrl}/CancelBasketItemPerson`;
    return ServiceApi.post(url, params);
  },
  getTicket: (id) => {
    const url = `${baseServiceUrl}/GetTicket?basketItemId=${id}`;
    return ServiceApi.get(url);
  },
  // getFile: (params) => {
  //   return ServiceApi.get(`/api/v1/filesservicecontroler/getFile`, { params: params, responseType: 'blob' });
  // },
  // getFile: (params) => {
  //   const baseServiceUrlWebUpload = `/api/v1/filesservicecontroler`;
  //   const url = `${baseServiceUrlWebUpload}/getFile`;
  //     console.log("url==========",url);
  //     return  ServiceApi.get(url,  {params : params ,baseURL:env.REACT_APP_PHOTOPATH_WEB, responseType : 'blob'} );
  // },
  // getFile: (params) => {
  //   const baseServiceUrlWebUpload = `/api/v1/filesservicecontroler`;
  //   return ServiceApi.get(`${baseServiceUrlWebUpload}/getFile`, {
  //     params,
  //     baseURL: process.env.REACT_APP_PHOTOPATH_WEB,
  //     responseType: "blob",
  //   });
  // },
  getFile: (params) => {
    const baseServiceUrlWebUpload = `/api/v1/filesservicecontroler`;
    const url = `${baseServiceUrlWebUpload}/getFile`;
      return  ServiceApi.get(url,  {params : params ,baseURL:process.env.REACT_APP_PHOTOPATH_WEB, responseType : 'blob'} );

  }, 
  // getFile: (params) => {
  //   const baseServiceUrlWebUpload = `/api/v1/fileManager`;
  //   console.log("baseServiceUrlWebUpload==",baseServiceUrlWebUpload);
  //   return ServiceApi.get(`${baseServiceUrlWebUpload}/getFile`, {
  //     params,
  //     responseType: "blob",
  //   });
  // },
};

export default ApiBasketItemPerson;





